var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1296_30430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0C13.6816 0 0 13.6816 0 30.5C0 47.3184 13.6816 61 30.5 61C47.3184 61 61 47.3184 61 30.5C61 13.6816 47.3184 0 30.5 0Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8445 33.042H33.0423V43.8442C33.0423 45.2474 31.9039 46.3858 30.5007 46.3858C29.0976 46.3858 27.9592 45.2474 27.9592 43.8442V33.042H17.157C15.7538 33.042 14.6155 31.9037 14.6155 30.5005C14.6155 29.0973 15.7538 27.959 17.157 27.959H27.9592V17.1567C27.9592 15.7536 29.0976 14.6152 30.5007 14.6152C31.9039 14.6152 33.0423 15.7536 33.0423 17.1567V27.959H43.8445C45.2477 27.959 46.386 29.0973 46.386 30.5005C46.386 31.9037 45.2477 33.042 43.8445 33.042Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1296_30430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.7a93436e0c3a9e626f15db1d8382a6c9.svg";
export { ForwardRef as ReactComponent };